import React from 'react';

const ViewToggle = ({ view, onChange }) => (
  <div className="view-toggle" role="group" aria-label="Switch portfolio view">
    <button
      type="button"
      className={`vt-btn ${view === 'professional' ? 'active' : ''}`}
      onClick={() => onChange('professional')}
      aria-pressed={view === 'professional'}
    >
      <span className="vt-ico" aria-hidden="true">◆</span> Professional
    </button>
    <button
      type="button"
      className={`vt-btn ${view === 'terminal' ? 'active' : ''}`}
      onClick={() => onChange('terminal')}
      aria-pressed={view === 'terminal'}
    >
      <span className="vt-ico" aria-hidden="true">&gt;_</span> Terminal
    </button>
  </div>
);

export default ViewToggle;
